import styled from 'styled-components';
import { colors, weights } from '~/styles';

export const Filters = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
`;

export const Filter = styled.div`
  display: flex;
  align-items: center;

  &:not(:first-child) {
    margin-left: 1.5rem;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  text-align: left;
  padding: 0.75rem 1rem;
  font-size: 0.75rem;
  font-weight: ${weights.bold};
  color: ${colors.grey50};
  text-transform: uppercase;
  border-bottom: solid 1px ${colors.grey10};
`;

export const Td = styled.td`
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: ${colors.black};
  border-bottom: solid 1px ${colors.grey10};
  vertical-align: top;
`;

export const Mono = styled.span`
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Fira Mono', monospace;
  font-size: 0.75rem;
  color: ${colors.grey55};
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: ${colors.grey50};
  font-size: 0.875rem;
`;

export const BackLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: ${colors.grey55};
  margin-bottom: 1.5rem;
  cursor: pointer;

  &:hover {
    color: ${colors.black};
  }
`;

export const MetaHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1rem 0;
  margin-bottom: 1.5rem;
  border-bottom: solid 1px ${colors.grey10};
`;

export const MetaItem = styled.div`
  font-size: 0.875rem;
`;

export const MetaLabel = styled.div`
  font-size: 0.75rem;
  color: ${colors.grey50};
  margin-bottom: 0.25rem;
`;

// Entity display primitives (used in filters, list table, and detail page)
export const EntityRow = styled.div`
  display: flex;
  align-items: center;
`;

export const EntityIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size || '1.5rem'};
  height: ${({ $size }) => $size || '1.5rem'};
`;

export const EntityImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const EntityInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
  min-width: 0;
`;

export const EntityName = styled.div`
  font-size: 0.8125rem;
  font-weight: ${weights.bold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EntityDetail = styled.div`
  font-size: 0.6875rem;
  color: ${colors.grey55};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const JsonBlock = styled.pre`
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Fira Mono', monospace;
  font-size: 0.75rem;
  line-height: 1.4;
  background: ${colors.grey5};
  border: solid 1px ${colors.grey10};
  border-radius: 0.25rem;
  padding: 0.75rem;
  max-height: 20rem;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
`;
